import React from 'react';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import { FaEnvelope, FaInstagram, FaLinkedinIn, FaGithub, FaWhatsapp } from 'react-icons/fa';
// import { SiTailwindcss, SiFigma, SiNextdotjs } from "react-icons/si";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ['UIUX Designer.', 'FrontEnd Web Developer.'],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY PORTOTYPE</h4>
        <h1 className="text-6xl font-bold text-white">
          I'm <span className="text-designColor capitalize">Farah Aryaresta</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor cursorBlinking="false" cursorStyle="|" cursorColor="#FFD700" />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">Welcome to my official Portfolio Website Where I put all my work related to the website I created and much more</p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <a href="mailto:faraaryaresta@gmail.com" target="_blank" rel="noopener noreferrer">
                <FaEnvelope />
              </a>
            </span>
            <span className="bannerIcon">
              <a href="https://github.com/faraaryaresta/" target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </a>
            </span>
            <span className="bannerIcon">
              <a href="https://instagram.com/faraaryarestaa_" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </span>
            <span className="bannerIcon">
              <a href="https://wa.me/0895363416758" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
            </span>
            <span className="bannerIcon">
              <a href="https://www.linkedin.com/in/farah-aryaresta-158762244/" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </span>
          </div>
        </div>
        {/* <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <FaReact />
            </span>
            <span className="bannerIcon">
              <SiNextdotjs />
            </span>
            <span className="bannerIcon">
              <SiTailwindcss />
            </span>
            <span className="bannerIcon">
              <SiFigma />
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default LeftBanner;
